import React from 'react';
import { Field } from '../Form';
import { renderFields, FormExtensionContext } from '../formUtils';
import Label from '@dashboard/components/Form/components/Label';
import clsx from 'clsx';

function Columns({
  columns,
  fields,
  className,
  inputClassName,
  gap = 'base',
  isDesignForm = true,
  values,
  setFieldValue,
  errors,
  touched,
  label,
  labelDescription,
  tooltip,
  tags,
  optional,
  hideOptional,
  hideLabel,
}) {
  const {
    customFieldPropsAreEqual,
    customLeafFieldNames,
    customContainerChildrenPropsEqual,
    customContainerValuesEqual,
  } = React.useContext(FormExtensionContext);

  return (
    <>
      {!!label && !hideLabel && (
        <Label
          optional={optional && !hideOptional}
          tooltip={tooltip}
          tags={tags}
          description={labelDescription}
        >
          {label}
        </Label>
      )}
      <div
        className={clsx(
          'grid',
          {
            'grid-cols-1': columns === 1,
            'grid-cols-2': columns === 2,
            'grid-cols-3': columns === 3,
            'grid-cols-4': columns === 4,
            'grid-cols-5': columns === 5,
            'grid-cols-6': columns === 6,
            'gap-x-2 gap-y-2': gap === 'sm',
            'gap-x-4 gap-y-2': gap === 'base',
            'gap-x-8 gap-y-2': gap === 'lg',
            'gap-y-2': isDesignForm,
          },
          className,
        )}
      >
        {renderFields({ fields, values, setFieldValue }).map(field => {
          return (
            <Field
              key={field.name}
              field={{
                ...field,
                visible: field.visible === undefined ? true : field.visible,
                noMargin: true,
              }}
              values={values}
              setFieldValue={setFieldValue}
              inputClassName={inputClassName}
              errors={errors}
              touched={touched}
              customFieldPropsAreEqual={customFieldPropsAreEqual}
              customLeafFieldNames={customLeafFieldNames}
              customContainerChildrenPropsEqual={customContainerChildrenPropsEqual}
              customContainerValuesEqual={customContainerValuesEqual}
            />
          );
        })}
      </div>
    </>
  );
}

export default React.memo(Columns);
